import { useEffect, useState } from "react";
import { computeCapability } from "./capability";

function readInputs() {
  const reducedMotion = typeof window.matchMedia === "function"
    && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const pointerFine = typeof window.matchMedia === "function"
    && window.matchMedia("(pointer: fine)").matches;
  return { reducedMotion, pointerFine, viewportWidth: window.innerWidth };
}

// Re-evaluated on resize and on the two media queries changing (e.g. a user
// toggling reduced-motion in OS settings mid-session, or docking/undocking a
// touch device) — capability is not a one-time mount-time snapshot.
export function useCapability() {
  const [capability, setCapability] = useState(() =>
    typeof window === "undefined" ? { renderCursor: false } : computeCapability(readInputs())
  );

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const recompute = () => setCapability(computeCapability(readInputs()));
    window.addEventListener("resize", recompute, { passive: true });
    const mqReduced = window.matchMedia("(prefers-reduced-motion: reduce)");
    const mqPointer = window.matchMedia("(pointer: fine)");
    mqReduced.addEventListener("change", recompute);
    mqPointer.addEventListener("change", recompute);
    return () => {
      window.removeEventListener("resize", recompute);
      mqReduced.removeEventListener("change", recompute);
      mqPointer.removeEventListener("change", recompute);
    };
  }, []);

  return capability;
}
